const hu = {
  accept: "Elfogad",
  changeLanguage: "Nyelvválasztás",
  footer: {
    mainPage: {
      mainPageText1: "SZEMÉLYRE SZABOTT MEGOLDÁSOK. PONT ÚGY, AHOGY ÖN SZERETNÉ.",
      askForOffer: "Kérjen ajánlatot most!",
      aboutUs: "Rólunk",
      solutions: "Megoldások",
      socialMedia: "Social-Media",
      aboutInvitech: "Az Invitechről",
      references: "Referenciák",
      career: "Karrier",
      socialResponsibility: "Társadalmi felelősségvállalás",
      centralizedProcurement: "Központosított beszerzés",
      smartVillage: "Okosfalu",
      forLargeCompanies: "Nagyvállalatoknak",
      forSmallAndMediumCompanies: "Kis és középvállalkozásoknak",
      forInstitutions: "Intézményeknek",
      forWholesalers: "Nagykereskedőknek",
      businessServices: "Vállalati szolgáltatások",
      infrastructureServices: "Infrastruktúra szolgáltatások",
      news: "Hírek",
      press: "Sajtó",
      blog: "Blog",
      loginToCustomerPortal: "Belépés az ügyfélportálra",
      loginToTechnicalPortal: "Belépés a technikai portálra"
    },
    dataProtection: "Adatvédelem",
    dataProcessingCode: "Adatfeldolgozói kódex",
    termsAndConditions: "ÁSZF",
    gtc: "ÁSZF",
    certificates: "Tanúsítványaink",
    impress: "Impresszum",
    providerInformation: "Szolgáltató adatai",
    filteringSoftware: "Szűrőszoftver",
    coServiceOffers: "Társszolgáltatói ajánlatok",
    premiumServices: "Emelt díjas szolgáltatások",
    socialResponsibility: "Társadalmi felelősségvállalás (InnoMax)",
    iivrApplication: "IIVR Pályázat"
  },
  urls: {
    aboutInvitech: "https://www.invitech.hu/invitechrol",
    references: "https://www.invitech.hu/ugyfeleink",
    socialResponsibility: "https://www.invitech.hu/innomax-fooldal",
    centralizedProcurement: "https://www.invitech.hu/kozpontositott-beszerzes",
    forLargeCompanies: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
    forSmallAndMediumCompanies: "https://www.invitech.hu/kis-es-kozepvallalkozasok-gyujto",
    forInstitutions: "https://www.invitech.hu/kozpontositott-beszerzes",
    businessServices: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
    infrastructureServices: "https://www.invitech.hu/infrastruktura",
    news: "https://www.invitech.hu/hirek",
    dataProcessingCode: "https://www.invitech.hu/storage/pbB0key1ENoZhpMpb0LVtlWc9sgyyEU6eIrQ98by.pdf",
    gtc: "https://www.invitech.hu/altalanos-szerzodesi-feltetelek-invitech",
    certificates: "https://www.invitech.hu/tanusitvanyaink",
    impress: "https://www.invitech.hu/impresszum",
    providerInformation: "https://www.invitech.hu/szolgaltato-adatai"
  },
  fields: {
    rating: "Kérjük, röviden ossza meg velünk, hogyan javíthatnánk a szolgáltatásaink színvonalán: (opcionális)",
    ratingPlace: "Ide írja be üzenetét",
    ratingCheck: "Hozzájárulok, hogy az One a megadott válaszommal kapcsolatban telefonon felkeressen"
  },
  cannotBeEmpty: "Nem lehet üres",
  formatError: "Formátum hiba",
  mobileFormatError: "Formátum hiba (pl. +36...)",
  taxFormatError: "Formátum hiba (pl. 12345678-1-12)",
  title: "Üdvözöljük az One ügyfélelégedettségi rendszerében!",
  desc: "Kérjük erősítse meg ",
  desc2: " pontos értékelését!",
  mandatory: "kötelezően kitöltendő",
  success: "Sikeres",
  errorDuringRegistration: "Hiba a regisztrációs folyamat közben. Kérem, próbálja újra!",
  send: "Értékelés elküldése",
  dearCustomer: "Kedves Partnerünk!",
  sentMessage: "Köszönjük, hogy megtisztelt mindet bizalmával, és visszajelzésével segíti munkánkat.",
  sentMessageGood:"Köszönjük, hogy megtisztelt mindet bizalmával, és visszajelzésével segíti munkánkat. Nagy öröm számunkra, hogy elégedett ügyfeleink között üdvözölhetjük!"
};

export default hu;
